<aside class='overflow-hidden d-flex flex-grow-1 flex-row'>
  <section class='position-relative'>
    <mat-divider class='position-absolute dock-right height-100p' vertical='true'></mat-divider>
    <app-filter-nav-state (eventChangeStatus)='changeFilterStatus($event)' (eventChangeManager)='changeManager($event)' [manager]='activeManager'></app-filter-nav-state>
  </section>
  <section class='d-flex flex-column flex-fill p-2'>
    <app-approval-requests-view *ngIf='activeManager' #approvalRequestsView [manager]='activeManager' [status]='activeStatus'></app-approval-requests-view>
  </section>
</aside>
